import { Badge } from '@mui/icons-material';
import { List, ListItem, styled, Typography } from '@mui/material';
import React from 'react';

const StyledLink = styled('a')({
  color: 'inherit',
  textDecoration: 'none',
  ':hover': {
    textDecoration: 'underline',
  },
});

const StyledListItem = styled(ListItem)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  paddingTop: '0',
  paddingBottom: '10px',
});

const Trainings: React.FC = () => {
  return (
    <>
      <Typography
        variant="subtitle2"
        sx={{
          height: '20px',
          color: '#0047FF',
          margin: 0,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        AI SKILL DEVELOPMENT
      </Typography>
      <div style={{ height: 'inherit' }}>
        <List sx={{ height: 'inherit', marginTop: '10px', paddingTop: '0', paddingBottom: '0' }}>
          <StyledListItem>
            <Typography variant="body2">
              <StyledLink
                href="https://westmonroe.degreed.app/plan/3591284?orgsso=westmonroe"
                target="_blank"
                style={{
                  lineHeight: '20px',
                  fontSize: '14px',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Badge sx={{ width: '18px', mr: '3px' }} />
                  <b>GenAI 101 - Working Smarter with Nigel Badge</b>
                </div>
              </StyledLink>
            </Typography>

            <Typography variant="body2">
              Build foundational AI skills with Nigel and earn your badge to boost productivity and
              client value.{' '}
            </Typography>
          </StyledListItem>
          <StyledListItem>
            <Typography variant="body2">
              <StyledLink
                href="https://westmonroe.degreed.app/plan/3391588?orgsso=westmonroe&tltag=6f18632e-77d7-40a7-a94c-84f6cea37404"
                target="_blank"
                style={{
                  lineHeight: '20px',
                  fontSize: '14px',
                }}
              >
                <b>📘 Prompt Engineering Badge & Pathways</b>
              </StyledLink>
            </Typography>
            <Typography variant="body2">
              Take the assessment or dive into the 101-103 pathways to master prompt engineering and
              earn your badge.
            </Typography>
          </StyledListItem>
        </List>
      </div>
    </>
  );
};

export default Trainings;
